import {
  Component,
  OnInit
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { JsonPipe, NgClass, NgIf } from '@angular/common';
import { StorageService } from '../../../../shared/services/storage.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { ProfileImageService } from '../../../../shared/services/profile-image.service';
import { ChatDataService } from '../../../../shared/services/chat-data.service';
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  standalone: true,
  imports: [MatRippleModule, MatIconModule, JsonPipe, NgIf, NgClass],
  providers: [StorageService]
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean = false;
  user: any;
  userImageUrl: string;
  s3_bucket_url = environment.s3_bucket_url;
  // Slack-style "Set yourself as away" (toggled from the Chat page's Status
  // menu) -- this avatar's dot is the one place showing it everywhere else
  // in the app, not just the chat page itself, so it needs its own fetch
  // rather than reading chat.component's local state.
  manualStatus: 'active' | 'away' = 'active';
  constructor(
    private popover: VexPopoverService,
    private authService: AuthService,
    private imageService: ProfileImageService,
    private chatDataService: ChatDataService
  ) {
    this.authService.self().subscribe((data) => {
      if (data && data.id) {
        this.user = data;
        this.userImageUrl = this.user.profile_image;
      }
    });
    this.imageService.getData().subscribe((data) => {
      this.userImageUrl = data;
    });
    this.chatDataService.fromWebsocket$.subscribe((msg: any) => {
      if (msg?.type !== 'MANUAL_STATUS') return;
      this.manualStatus = msg.data?.status === 'away' ? 'away' : 'active';
    });
    this.chatDataService.sendToWebsocket({ type: 'GET_MANUAL_STATUS' });
  }

  ngOnInit() {}


  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
    });
    this.getSelf();
  }

  getSelf() {
    this.authService.self().subscribe((data) => {
      if (data && data.id) {
        this.user = data;
      }
    });
  }
}
